import React, { memo, useMemo } from 'react';
import Money from '../../../helpers/utils/money/money';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';

function UserItem({ user, onChange, checked }) {
  console.log(user);
  return (
    <div className='row g-3 pb-2'>
      <div className='col-md-1'>
        <div className='h-100 d-flex align-items-center justify-content-center'>
          <ChecksGroup>
            <Checks
              type='switch'
              id={`user_${user.id}`}
              name='users'
              value={user.id}
              onChange={onChange}
              checked={checked}
              isInline
            />
          </ChecksGroup>
        </div>
      </div>
      <div className='col-md-8'>
        <FormGroup>
          <Input value={user.name} disabled readOnly />
        </FormGroup>
      </div>
      <div className='col-md-2'>
        <FormGroup>
          <Input value={user.type} disabled readOnly />
        </FormGroup>
      </div>

    </div>
  );
}

const UserElement = memo(UserItem);

function Listusers({ hidden, users, usersSelected, onChange }) {



  const Header = useMemo(() => (
    <div>

      <div className='row g-4 pt-2'>
        <div className='col-md-1'>
          <p>#</p>
        </div>

        <div className='col-md-8'>
          <p>Nome</p>
        </div>
      </div>
    </div>

  ), []);

  if (!usersSelected) return null;

  return (
    <div style={{ maxHeight: 300 }} className='overflow-y' hidden={hidden}>
      {Header}
      {users.map((user, index) => (
        <UserElement
          key={'ch_comp' + index}
          user={user}
          onChange={onChange}
          checked={usersSelected.includes(user.id)}
        />
      ))}
    </div>
  );
}

export default memo(Listusers);